export default "__VITE_ASSET__DDh8_mai__"